import { NumberInput, useSimpleFormIteratorItem } from "react-admin";
import { Grid } from "@mui/material";

const IndexField = () => {
  const { index } = useSimpleFormIteratorItem();
  return (
    <Grid
      item
      xs={12}
      md={2}
    >
      <NumberInput
        readOnly
        source="commissionNumber"
        label="Комисия #"
        defaultValue={index + 1}
      />
    </Grid>
  );
};

export default IndexField;
